import request from '@/router/axios'

export function fetchList(query) {
  return request({
    url: '/admin/employee/page',
    method: 'get',
    params: query
  })
}

export function addObj(obj) {
  return request({
    url: '/admin/employee',
    method: 'post',
    data: obj
  })
}

export function getObj(id) {
  return request({
    url: '/admin/employee/' + id,
    method: 'get'
  })
}

export function delObj(id) {
  return request({
    url: '/admin/employee/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/admin/employee',
    method: 'put',
    data: obj
  })
}
